import type React from 'react';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => (
  <main className="sign-in-required" aria-labelledby="sign-in-required-title">
    <div className="sign-in-required__card">{children}</div>
  </main>
);
